export const JURISDICTION_MASTER_STATUS_KEYS = {
  FEEDER: 'FEEDER',
  NONE: 'NONE',
  MASTER: 'MASTER'
};

export const jursdictionsMasterStatusLabels = {
  [JURISDICTION_MASTER_STATUS_KEYS.FEEDER]: 'Feeder',
  [JURISDICTION_MASTER_STATUS_KEYS.MASTER]: 'Master'
};

export const jurisdictionsMasterStatusList = [
  {
    label: 'None',
    value: JURISDICTION_MASTER_STATUS_KEYS.NONE
  },
  {
    label: jursdictionsMasterStatusLabels[JURISDICTION_MASTER_STATUS_KEYS.FEEDER],
    value: JURISDICTION_MASTER_STATUS_KEYS.FEEDER
  },
  {
    label: jursdictionsMasterStatusLabels[JURISDICTION_MASTER_STATUS_KEYS.MASTER],
    value: JURISDICTION_MASTER_STATUS_KEYS.MASTER
  }
];
